export const uk = {
    bannersNo: 'Объявление',
    changedParameter: 'Параметр изменения',
    changedValue: 'Что изменилось',
    cid: 'Кампания',
    date: 'Дата и время',
    groupNo: 'Группа',
    'moscow-time': 'Время московское',
    number: '№',
    userName: 'Кто изменил'
};
